//@import dependencies
import React, {CSSProperties} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../avatarCommon.scss'

// @ADD Component types
interface IAvatarCommonLayoutProps {
  name?: string
  src: string
  size?: string
  rounded?: boolean
  circle?: boolean
  active?: boolean
  style?: CSSProperties
  onClick?: ()=>void
}

const AvatarCommonLayout: React.FC<IAvatarCommonLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [colors] = useColors()

  return(
    <div onClick={props.onClick} className={`avatar-component ${props.rounded ? 'avatar-rounded' : undefined} ${props.circle ? 'avatar-circle' : undefined}`} style={props.style}>
      <div
        style={{
          backgroundImage: `url('${props.src}')`,
          width: props.size,
          height: props.size,
        }}
        title={props.name}
      >
        {props.active ? <div style={{borderColor: colors.primary, width: props.size, height: props.size}} className='active-avatar'></div> : null}
      </div>

    </div>
  )
}

export default AvatarCommonLayout
